import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/contractWarehouses',
  component: Layout,
  name: 'contractWarehouses',
  redirect: '/contractWarehouses/index',
  children: [{
    path: '/contractWarehouses/index',
    component: () => import('@/views/contractWarehouses/index'),
    name: 'contractWarehouses.index',
    meta: {
      title: i18n.t(`message.suppliers_aggrement`)
    }
  }]
}

export default paymentType